import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles, GlassWater, Utensils } from "lucide-react";
import aboutImg1 from "../assets/about us 1.jpg";
import aboutImg2 from "../assets/about us 2.webp";
import "../styles/StorySection.css";

function StorySection({ scrollTo }) {
  return (
    <section id="story" className="story section">
      <div className="story-container">
        {/* Left Column: Narrative Content */}
        <motion.div
          className="story-left"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="story-header-meta">
            <span className="section-index">01 / 05</span>
            <span className="kicker">THE JALSA SPIRIT</span>
          </div>

          <h2 className="story-heading">
            Not just a night out.<br />
            <i className="gold-accent-text">A state of mind.</i>
          </h2>

          <div className="gold-divider" />

          <p className="lead story-lead">
            Against the backdrop of Bengaluru’s vibrant nightlife, Jalsa is an establishment matching the city's true spirit — abundant in simple pleasures and extraordinary moments.
          </p>

          <div className="story-highlights">
            <div className="story-pill">
              <Sparkles size={15} />
              <span>Tastefully Wasted</span>
            </div>
            <div className="story-pill">
              <GlassWater size={15} />
              <span>Craft Mixology</span>
            </div>
            <div className="story-pill">
              <Utensils size={15} />
              <span>Generous Comforts</span>
            </div>
          </div>

          <div className="story-action">
            <button className="gold-btn" onClick={() => scrollTo("contact")}>
              Discover the space <ArrowUpRight size={17} />
            </button>
          </div>
        </motion.div>

        {/* Right Column: Custom Arch Image Stack */}
        <div className="story-visual-container">
          <div className="story-visual-wrapper">
            {/* Big Image: Slides smoothly from the RIGHT first */}
            <motion.div
              className="arch-frame big-frame"
              initial={{ opacity: 0, x: 140 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            >
              <img
                src={aboutImg1}
                alt="The Jalsa Spirit - Main Ambience"
                className="arch-img"
              />
              <div className="arch-overlay" />
            </motion.div>

            {/* Small Image: Slides smoothly from the LEFT later */}
            <motion.div
              className="arch-frame small-frame"
              initial={{ opacity: 0, x: -140 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 1.0, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="small-frame-inner">
                <img
                  src={aboutImg2}
                  alt="The Jalsa Spirit - Dining & Drinks"
                  className="arch-img"
                />
                <div className="arch-overlay" />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default StorySection;
